import { ColumnItemDto } from '../../../webapi/index';
import { ColumnFieldTypeObject } from './ColumnFieldTypeObject';
import { FormatDto } from './FormatDto';

export class ColumnInfoDto<T> extends ColumnItemDto<T> {
  override ColumnName: T; // This isn't needed in here since it's defined in ColumnItemDto but keeping it for clarity
  HeaderDisplayName: string;
  FieldTypeObject: ColumnFieldTypeObject;
  Width?: number;
  DisplayWidth?: number;
  Format?: FormatDto;
}
